const zoom_container = document.querySelector('#zoom-image')
const zoom_main_image = document.querySelector('#zoom-main-image img')
const zoom_main_stage = document.querySelector('#zoom-main-image')
const zoom_thumbs = document.querySelectorAll('#zoom-thumbs img')

const prev_btn_zoom = document.querySelectorAll('#prev-btn-zoom')
const next_btn_zoom = document.querySelectorAll('#next_btn_zoom')

const SWIPE_THRESHOLD = 48
const ZOOM_SLIDE_DISTANCE = '100%'
const ZOOM_SLIDE_DURATION = 440
const ZOOM_EASING = 'cubic-bezier(0.22, 1, 0.36, 1)'

let isZoomAnimating = false

function isZoomOpen() {
    return Boolean(zoom_container) && !zoom_container.classList.contains('hidden')
}

function closeZoom() {
    if (!zoom_container) return

    zoom_container.classList.add('hidden')
}

function openZoomContainer() {
    if (!zoom_container) return

    zoom_container.classList.remove('hidden')
}

function getZoomSrc(image) {
    if (!image) return ''

    return image.dataset.zoomSrc || image.currentSrc || image.getAttribute('src') || ''
}

function getZoomAlt(image) {
    if (!image) return ''

    return image.getAttribute('alt') || ''
}

function getActiveZoomIndex() {
    let activeIndex = -1

    zoom_thumbs.forEach((thumb, index) => {
        if (thumb.classList.contains('active')) {
            activeIndex = index
        }
    })

    return activeIndex
}

function resetZoomTransform() {
    scale = 1
    currentScale = 1
    translateX = 0
    translateY = 0
    isPanning = false

    if (img) {
        img.style.transform = ''
        img.style.transition = ''
    }

    if (zoom_main_image) {
        zoom_main_image.style.transform = ''
    }
}

function waitForAnimation(animation) {
    if (!animation) return Promise.resolve()

    return animation.finished.catch(() => {})
}

function preloadZoomImage(src) {
    if (!src) return Promise.resolve()

    return new Promise((resolve) => {
        const preloader = new Image()
        preloader.onload = () => resolve()
        preloader.onerror = () => resolve()
        preloader.src = src
    })
}

function createZoomClone() {
    if (!zoom_main_image || !zoom_main_stage) return null

    const clone = zoom_main_image.cloneNode(true)
    clone.classList.add('zoom-main-image__clone')
    clone.removeAttribute('id')
    zoom_main_stage.appendChild(clone)
    return clone
}

async function animateZoomImageTransition(nextSrc, nextAlt, direction) {
    if (!zoom_main_image || !zoom_main_stage || !direction || !zoom_main_image.animate) {
        zoom_main_image.src = nextSrc
        zoom_main_image.alt = nextAlt
        return
    }

    const clone = createZoomClone()
    const startOffset = direction > 0 ? ZOOM_SLIDE_DISTANCE : '-100%'
    const endOffset = direction > 0 ? '-100%' : ZOOM_SLIDE_DISTANCE

    zoom_main_image.src = nextSrc
    zoom_main_image.alt = nextAlt
    zoom_main_image.style.transform = `translate3d(${startOffset}, 0, 0)`

    const enteringAnimation = zoom_main_image.animate(
        [
            { transform: `translate3d(${startOffset}, 0, 0)` },
            { transform: 'translate3d(0, 0, 0)' }
        ],
        {
            duration: ZOOM_SLIDE_DURATION,
            easing: ZOOM_EASING,
            fill: 'forwards'
        }
    )

    let leavingAnimation = null
    if (clone && clone.animate) {
        leavingAnimation = clone.animate(
            [
                { transform: 'translate3d(0, 0, 0)' },
                { transform: `translate3d(${endOffset}, 0, 0)` }
            ],
            {
                duration: ZOOM_SLIDE_DURATION,
                easing: ZOOM_EASING,
                fill: 'forwards'
            }
        )
    }

    await Promise.all([
        waitForAnimation(enteringAnimation),
        waitForAnimation(leavingAnimation)
    ])

    zoom_main_image.style.transform = ''
    clone?.remove()
}

async function setZoomImage(image, options = {}) {
    if (!zoom_main_image || !image || isZoomAnimating) return

    const { animate = false, direction = 0 } = options
    const nextSrc = getZoomSrc(image)
    const nextAlt = getZoomAlt(image)

    if (!nextSrc) return

    const currentSrc = zoom_main_image.getAttribute('src') || ''
    if (currentSrc === nextSrc && animate === false) {
        resetZoomTransform()
        return
    }

    isZoomAnimating = true
    await preloadZoomImage(nextSrc)
    resetZoomTransform()

    if (animate && currentSrc && currentSrc !== nextSrc) {
        await animateZoomImageTransition(nextSrc, nextAlt, direction)
    } else {
        zoom_main_image.src = nextSrc
        zoom_main_image.alt = nextAlt
    }

    resetZoomTransform()
    isZoomAnimating = false
}

function updateActiveThumb() {
    if (!zoom_main_image) return

    const currentImgSrc = zoom_main_image.getAttribute('src') || ''

    zoom_thumbs.forEach((thumb) => {
        thumb.classList.remove('active')

        if (getZoomSrc(thumb) === currentImgSrc || thumb.src.includes(currentImgSrc)) {
            thumb.scrollIntoView({
                behavior: 'smooth',
                inline: 'center',
                block: 'nearest'
            })
            thumb.classList.add('active')
        }
    })
}

function updateNavigationButtons() {
    const canLoop = zoom_thumbs.length > 1

    prev_btn_zoom.forEach((prev) => {
        prev.disabled = !canLoop
    })

    next_btn_zoom.forEach((next) => {
        next.disabled = !canLoop
    })
}

async function goToZoomIndex(index, direction = 0, animate = true) {
    const target = zoom_thumbs[index]

    if (!target) return

    await setZoomImage(target, { animate, direction })
    updateActiveThumb()
    updateNavigationButtons()
}

async function navigateZoom(direction, animate = true) {
    if (!zoom_thumbs.length || isZoomAnimating) return

    const activeIndex = getActiveZoomIndex()

    if (direction < 0) {
        const prevIndex = activeIndex <= 0 ? zoom_thumbs.length - 1 : activeIndex - 1
        await goToZoomIndex(prevIndex, -1, animate)
        return
    }

    const nextIndex = activeIndex >= zoom_thumbs.length - 1 || activeIndex === -1 ? 0 : activeIndex + 1
    await goToZoomIndex(nextIndex, 1, animate)
}

async function openZoom(el) {
    openZoomContainer()

    const image = el.querySelector('img')

    if (image) {
        if (el.dataset.zoomSrc) {
            image.dataset.zoomSrc = el.dataset.zoomSrc
        }

        await setZoomImage(image, { animate: false, direction: 0 })
    }

    updateActiveThumb()
    updateNavigationButtons()
}

function openZoomFromGallery(button) {
    const slider = button.closest('.slider-pdp')

    if (!slider) return

    const activeSlideImage = slider.querySelector('.splide__slide.is-active .product__imageWrapper')
    const fallbackSlideImage = slider.querySelector('.product__imageWrapper')
    const targetImage = activeSlideImage || fallbackSlideImage

    if (!targetImage) return

    openZoom(targetImage)
}

zoom_thumbs.forEach((zoomThumb, index) => {
    zoomThumb.addEventListener('click', async (e) => {
        const image = e.target
        const activeIndex = getActiveZoomIndex()
        let direction = 0

        if (activeIndex !== -1 && index !== activeIndex) {
            direction = index > activeIndex ? 1 : -1
        }

        await setZoomImage(image, { animate: direction !== 0, direction })
        updateActiveThumb()
        updateNavigationButtons()
    })
})

prev_btn_zoom.forEach((prev) => {
    prev.addEventListener('click', () => {
        navigateZoom(-1, true)
    })
})

next_btn_zoom.forEach((next) => {
    next.addEventListener('click', () => {
        navigateZoom(1, true)
    })
})

document.addEventListener('keydown', (event) => {
    if (!isZoomOpen() || isZoomAnimating) return

    if (event.key === 'ArrowLeft') {
        event.preventDefault()
        navigateZoom(-1, true)
    }

    if (event.key === 'ArrowRight') {
        event.preventDefault()
        navigateZoom(1, true)
    }

    if (event.key === 'Escape') {
        event.preventDefault()
        closeZoom()
    }
})

const container = document.querySelector('#zoom-main-image')

let img = null

let scale = 1
let currentScale = 1
let startDistance = 0
let translateX = 0
let translateY = 0
let startX = 0
let startY = 0
let isPanning = false
let swipeStartX = null
let swipeStartY = null
let swipeCurrentX = null
let swipeCurrentY = null
let pointerSwipeStartX = null
let pointerSwipeStartY = null
let pointerSwipeCurrentX = null
let pointerSwipeCurrentY = null
let isPointerDragging = false

function getDistance(touches) {
    const [a, b] = touches
    return Math.hypot(
        b.clientX - a.clientX,
        b.clientY - a.clientY
    )
}

function getBounds() {
    const containerRect = container.getBoundingClientRect()

    const imgWidth = containerRect.width * currentScale
    const imgHeight = containerRect.height * currentScale

    const maxX = Math.max(0, (imgWidth - containerRect.width) / 2)
    const maxY = Math.max(0, (imgHeight - containerRect.height) / 2)

    return { maxX, maxY }
}

function render() {
    if (!img) return

    const { maxX, maxY } = getBounds()

    translateX = Math.max(-maxX, Math.min(translateX, maxX))
    translateY = Math.max(-maxY, Math.min(translateY, maxY))

    img.style.transform = `translate(${translateX}px, ${translateY}px) scale(${currentScale})`
}

function handleSwipeGesture(startX, startY, endX, endY) {
    if (startX === null || endX === null || currentScale > 1) return

    const deltaX = endX - startX
    const deltaY = endY - startY

    if (Math.abs(deltaX) < SWIPE_THRESHOLD || Math.abs(deltaX) <= Math.abs(deltaY)) return

    navigateZoom(deltaX > 0 ? -1 : 1, true)
}

if (container) {
    container.addEventListener('dragstart', (event) => {
        event.preventDefault()
    })

    container.querySelectorAll('img, a').forEach((node) => {
        node.setAttribute('draggable', 'false')
    })

    container.addEventListener('touchstart', (e) => {
        img = container.querySelector('img')

        if (!img) return

        img.style.transition = 'none'

        if (e.touches.length === 2) {
            startDistance = getDistance(e.touches)
            swipeStartX = null
            swipeStartY = null
            swipeCurrentX = null
            swipeCurrentY = null
        }

        if (e.touches.length === 1) {
            swipeStartX = e.touches[0].clientX
            swipeStartY = e.touches[0].clientY
            swipeCurrentX = swipeStartX
            swipeCurrentY = swipeStartY
        }

        if (e.touches.length === 1 && currentScale > 1) {
            isPanning = true
            startX = e.touches[0].clientX - translateX
            startY = e.touches[0].clientY - translateY
        }
    })

    container.addEventListener('touchmove', (e) => {
        if (!img) return

        if (e.touches.length === 2) {
            const newDistance = getDistance(e.touches)
            const delta = newDistance / startDistance

            currentScale = Math.min(Math.max(scale * delta, 1), 4)

            render()
            e.preventDefault()
        }

        if (e.touches.length === 1 && currentScale <= 1) {
            swipeCurrentX = e.touches[0].clientX
            swipeCurrentY = e.touches[0].clientY
        }

        if (e.touches.length === 1 && isPanning && currentScale > 1) {
            translateX = e.touches[0].clientX - startX
            translateY = e.touches[0].clientY - startY

            render()
        }
    }, { passive: false })

    container.addEventListener('touchend', () => {
        if (currentScale <= 1) {
            handleSwipeGesture(swipeStartX, swipeStartY, swipeCurrentX, swipeCurrentY)
        }

        scale = currentScale
        isPanning = false
        swipeStartX = null
        swipeStartY = null
        swipeCurrentX = null
        swipeCurrentY = null

        if (img) {
            img.style.transition = 'transform 0.15s ease-out'
        }
    })

    container.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse' || e.button !== 0 || currentScale > 1) return

        e.preventDefault()

        pointerSwipeStartX = e.clientX
        pointerSwipeStartY = e.clientY
        pointerSwipeCurrentX = e.clientX
        pointerSwipeCurrentY = e.clientY
        isPointerDragging = true
        container.setPointerCapture?.(e.pointerId)
    })

    container.addEventListener('pointermove', (e) => {
        if (e.pointerType !== 'mouse' || isPointerDragging === false || currentScale > 1) return

        e.preventDefault()

        pointerSwipeCurrentX = e.clientX
        pointerSwipeCurrentY = e.clientY
    })

    container.addEventListener('pointerup', (e) => {
        if (e.pointerType !== 'mouse' || pointerSwipeStartX === null) return

        pointerSwipeCurrentX = e.clientX
        pointerSwipeCurrentY = e.clientY
        handleSwipeGesture(pointerSwipeStartX, pointerSwipeStartY, pointerSwipeCurrentX, pointerSwipeCurrentY)
        pointerSwipeStartX = null
        pointerSwipeStartY = null
        pointerSwipeCurrentX = null
        pointerSwipeCurrentY = null
        isPointerDragging = false
        container.releasePointerCapture?.(e.pointerId)
    })

    container.addEventListener('pointercancel', () => {
        pointerSwipeStartX = null
        pointerSwipeStartY = null
        pointerSwipeCurrentX = null
        pointerSwipeCurrentY = null
        isPointerDragging = false
    })

    container.addEventListener('mousedown', (event) => {
        if (window.PointerEvent || event.button !== 0 || currentScale > 1) return

        event.preventDefault()
        pointerSwipeStartX = event.clientX
        pointerSwipeStartY = event.clientY
        pointerSwipeCurrentX = event.clientX
        pointerSwipeCurrentY = event.clientY
        isPointerDragging = true
    })

    window.addEventListener('mousemove', (event) => {
        if (window.PointerEvent || isPointerDragging === false || currentScale > 1) return

        event.preventDefault()
        pointerSwipeCurrentX = event.clientX
        pointerSwipeCurrentY = event.clientY
    })

    window.addEventListener('mouseup', (event) => {
        if (window.PointerEvent || pointerSwipeStartX === null) return

        pointerSwipeCurrentX = event.clientX
        pointerSwipeCurrentY = event.clientY
        handleSwipeGesture(pointerSwipeStartX, pointerSwipeStartY, pointerSwipeCurrentX, pointerSwipeCurrentY)
        pointerSwipeStartX = null
        pointerSwipeStartY = null
        pointerSwipeCurrentX = null
        pointerSwipeCurrentY = null
        isPointerDragging = false
    })
}





